import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConfirmModal } from '../../ui';
import Toast from '../../Toast';
import workflowService from '../../../services/workflowService';

/**
 * Delete Workflow confirm modal.
 * API unchanged: workflowService.deleteWorkflow → DELETE /workflow/delete
 */
const DeleteWorkflowModal = ({ onClose, isEdit }) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async e => {
      return await workflowService.deleteWorkflow(e);
    },
    onSuccess: response => {
      Toast({ type: 'success', message: response.detail });
      queryClient.invalidateQueries({ queryKey: ['get_all_workflows'] });
      onClose();
    },
    onError: err => {
      console.log(err);
      Toast({ type: 'error', message: err.detail });
    },
  });

  return (
    <ConfirmModal
      title="Delete Workflow"
      message={
        <p>
          Are you sure you want to delete{' '}
          <span className="text-white font-medium">{isEdit?.name || 'this workflow'}</span>? This action cannot be
          undone.
        </p>
      }
      confirmLabel="Delete"
      busyLabel="Deleting..."
      loading={mutation.isPending}
      onConfirm={() => mutation.mutate(isEdit?.workflow_id)}
      onClose={onClose}
    />
  );
};

export default DeleteWorkflowModal;
